import {combineReducers} from 'redux'
import auth from '../stores/auth'
import files from '../stores/files'
import uploads from '../stores/uploads'

export default combineReducers({
  auth,
  files,
  uploads
})
